import useMediaQuery from "@material-ui/core/useMediaQuery";

type Breakpoint = 'xs' | 'md'
type Breakpoints = {
  isXs: boolean;
  isMd: boolean;
  active: Breakpoint;
}

export const useBreakpoints = () => {
  const breakpoints: Breakpoints = {
    isXs: useMediaQuery("(max-width: 640px)"),
    isMd: useMediaQuery("(min-width: 960px)"),
    active: "xs"
  };
  if (breakpoints.isXs) breakpoints.active = "xs";
  if (breakpoints.isMd) breakpoints.active = "md";
  return breakpoints;
}